
import { FC, useMemo } from 'react';

import TrialsMetaContext from '@/contexts/data/TrialsMetadataContext';
import useGetTrialsMeta from '@/hooks/data/useGetTrialsMeta';
import IHasChildren from '@/types/components/IHasChildren';

interface ITrialsMetadataProviderProps extends IHasChildren { }

const TrialsMetadataProvider: FC<ITrialsMetadataProviderProps> = ({
    children
}) => {
    const trialsQuery = useGetTrialsMeta({}, { revalidateOnFocus: true });
    
    const context = useMemo(() => {
        return trialsQuery;
    }, [trialsQuery]);

    return (
        <TrialsMetaContext.Provider value={context}>
            {children}
        </TrialsMetaContext.Provider>
    )
}

export default TrialsMetadataProvider